import './Notifications.scss';
import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'app/store';
import * as Core from 'components/core';
import DismissNotification from 'app/actionCreators/DismissNotification';
type Props = {
  notifications: AppState['notifications'];
};
function mapAppStateToProps(appState: AppState): Props {
  return {
    notifications: appState.notifications,
  };
}
class Notifications extends React.Component<Props> {
  render() {
    const { ids, byId } = this.props.notifications;
    const notifications = ids.map((id) => {
      return byId[id];
    });
    return (
      <div className="Notifications">
        {notifications.map((notification) => (
          <Notification key={notification.id} {...notification} />
        ))}
      </div>
    );
  }
}
type NotificationProps = {
  id: string;
  message: string;
  dismissed: boolean;
  bad: boolean;
};
class Notification extends React.Component<NotificationProps> {
  dismiss = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    DismissNotification(this.props.id);
  };
  render() {
    const { message, bad, dismissed } = this.props;
    const classNames = [
      'Notifications-notification',
      dismissed && 'dismissed',
      bad && 'Notifications-notification__bad',
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <div className={classNames}>
        {message}
        <Core.Button textLink onClick={this.dismiss}>
          dismiss
        </Core.Button>
      </div>
    );
  }
}
export default connect(mapAppStateToProps)(Notifications);
